import { AutoComplete, Box, Input, listItemSelectBuilder } from '@wix/design-system'
import { DropdownLayoutOption } from '@wix/design-system/dist/types/DropdownLayout'
import React, { FC } from 'react'

import { useViewport } from '../../../hooks/useViewport'
import { ALL_COUNTRY_CODES } from './consts'
import { CountryCode } from './types'

interface DropdownProps {
  value: CountryCode
  onChange: (countryCode: CountryCode) => void
}

const getCountryFlag = (countryCode: CountryCode) => (
  <img
    loading="lazy"
    src={`https://static.parastorage.com/unpkg/@wix/wix-locale-data@0.0.3632/dist/images/svg-country-flags/${countryCode.key}.svg`}
    alt={countryCode.key}
  />
)

const getLabel = (countryCode: CountryCode) => `${countryCode.shortKey} ${countryCode.dialCode}`

export const Dropdown: FC<DropdownProps> = ({ value, onChange }) => {
  const { viewport } = useViewport()
  const [optionsFilterCriteria, setOptionsFilterCriteria] = React.useState<string | null>(null)
  const flagSize = viewport === 'mobile' ? '18px' : '24px'

  const dropdownOptions = (
    optionsFilterCriteria
      ? ALL_COUNTRY_CODES.filter(countryCode => {
          const filterCriteria = optionsFilterCriteria.toLocaleLowerCase()

          return (
            countryCode.key.toLowerCase().includes(filterCriteria) ||
            countryCode.shortKey?.toLowerCase().includes(filterCriteria) ||
            countryCode.dialCode?.toLowerCase().includes(filterCriteria)
          )
        })
      : ALL_COUNTRY_CODES
  )
    .filter(({ dialCode }) => Boolean(dialCode))
    .map(countryCode =>
      listItemSelectBuilder({
        id: countryCode.key,
        prefix: (
          <Box width={flagSize} height={flagSize}>
            {getCountryFlag(countryCode)}
          </Box>
        ),
        title: getLabel(countryCode),
      }),
    )

  const handleSelect = (option: DropdownLayoutOption) => {
    const value = ALL_COUNTRY_CODES.find(countryCode => countryCode.key === option.id)!

    setOptionsFilterCriteria(null)
    onChange(value)
  }

  return (
    <AutoComplete
      dropdownWidth="279px"
      options={dropdownOptions}
      selectedId={value.key}
      value={
        optionsFilterCriteria !== null
          ? optionsFilterCriteria
          : viewport === 'mobile'
          ? value.dialCode
          : getLabel(value)
      }
      valueParser={option => option.label}
      prefix={
        <Input.IconAffix>
          <Box width={flagSize} height={flagSize}>
            {getCountryFlag(value)}
          </Box>
        </Input.IconAffix>
      }
      onBlur={() => setOptionsFilterCriteria(null)}
      onChange={e => setOptionsFilterCriteria(e.target.value)}
      onSelect={handleSelect}
      focusOnSelectedOption
      popoverProps={{ placement: 'bottom-start' }}
    />
  )
}
